import { GetAdvancedParams } from '@app/shared';

export function buildLeadDetailsGetParams(leadId: number): GetAdvancedParams {
  return {
    filterGroups: [
      [
        {
          property: 'id',
          value: leadId.toString(),
          operator: 'Equals',
        },
      ],
    ],
    startRow: 0,
    endRow: 1,
    sortDirection: 'asc',
    sortProperty: 'id',
    includeDescription: true,
  };
}
